import { FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordValidator } from 'src/app/shared/validators/password.validator';
import { MAIL_PATTERN } from '../../utils/mail-pattern';
import { MarketingConsentsForm } from '../marketing-consents.form';
import { PHONE_PATTERN } from '../../utils/phone-pattern';
import { customEmailValidator } from '../../validators/custom-email.validator';

export class EmailVerificationForm extends FormGroup {
  constructor(code?: string) {
    super({
      code: new FormControl(code ? code : '', [Validators.required, Validators.minLength(6)]),
    });
  }

  get code() {
    return this.get('code') as FormControl;
  }
}

export class RegisterForm extends FormGroup {

  private UTMS: string;
  private PAY_BY_LINK_TOKEN: string;

  constructor(utms: string = '', payByLinkToken: string = '') {
    let emailGroup = new FormGroup({
      email: new FormControl('', [Validators.required, customEmailValidator, Validators.pattern(MAIL_PATTERN)]),
      acceptedRegulations: new FormControl([], [Validators.required]),
    });

    let phoneGroup = new FormGroup({
      phone: new FormControl('', [Validators.required, Validators.pattern(PHONE_PATTERN),
        Validators.required, Validators.minLength(9), Validators.maxLength(9)]),
    });
    let phoneVerificationGroup = new FormGroup({
      code: new FormControl('', [Validators.required, Validators.minLength(6),
        Validators.maxLength(6)]),
    });
    let passwordGroup = new FormGroup({
      password: new FormControl('', [Validators.required, passwordValidator()]),
    });

    super({
      addEmail: emailGroup,
      addPhone: phoneGroup,
      verifyPhone: phoneVerificationGroup,
      setPassword: passwordGroup,
      marketingConsents: new MarketingConsentsForm(),
      referralCode: new FormControl(''),
      surname: new FormControl('', [Validators.required]),
      tosAccepted: new FormControl('', [Validators.requiredTrue]),
    });

    this.UTMS = utms;
    this.PAY_BY_LINK_TOKEN = payByLinkToken;
  }


  get email(): FormControl {
    return this.get('addEmail').get('email') as FormControl;
  }

  get password(): FormControl {
    return this.get('setPassword').get('password') as FormControl;
  }

  get referralCode(): FormControl {
    return this.get('referralCode') as FormControl;
  }

  get tosAccepted(): FormControl {
    return this.get('tosAccepted') as FormControl;
  }

  get marketingConsents(): MarketingConsentsForm {
    return this.get('marketingConsents') as MarketingConsentsForm;
  }

  get utms(): string {
    return this.UTMS;
  }

  set utms(value: string) {
    this.UTMS = value;
  }

  get payByLinkToken(): string {
    return this.PAY_BY_LINK_TOKEN;
  }

  set payByLinkToken(value: string) {
    this.PAY_BY_LINK_TOKEN = value;
  }

  get allSelected(): boolean {
    return this.tosAccepted.value && this.allMarketingSelected;
  }

  get allMarketingSelected(): boolean {
    return this.marketingConsents.allMarketingSelected;
  }

  get anyMarketingSelected(): boolean {
    return this.marketingConsents.anyMarketingSelected;
  }

  get indeterminateSelection(): boolean {
    return !this.allSelected && (this.tosAccepted.value || this.anyMarketingSelected);
  }

  get indeterminateMarketingSelection(): boolean {
    return !this.allMarketingSelected && this.anyMarketingSelected;
  }

  public changeAllConsentsState(checked: boolean): void {
    this.tosAccepted.setValue(checked);
    this.marketingConsents.changeAllMarketingConsentsState(checked);
  }


}
